module.exports = __webpack_public_path__ + "static/media/tipstant-bw-circle.90915bd7.png";